module.exports = __webpack_public_path__ + "img/album01_17.8dbb04a1.jpg";